import { RootState } from "../StoreHooks";

export const getOrganizationFilters = (state: RootState) => {
  const { organizationFilters } = state.organizationFilters || {};

  return [...organizationFilters];
};
